<template>
  <div class="promotion-bar" v-show="componentStore.promotionBar.isShow">
    <div class="container" style="width: 100%;">
      <template v-if="promotionBarContent.length > 0">
        <!-- SSR and the first client render show the first slide as static HTML so the bar
             is in the first paint; the carousel (arrows, auto slide) is enabled after mount -->
        <sib-carousel
          v-if="isMounted && promotionBarContent.length > 1"
          :key="promotionBarContent.length"
          :items="promotionBarContent"
          :options="{ Dots: false }"
          v-slot="slotProps"
        >
          <div class="text--center" v-html="slotProps.item.value"></div>
        </sib-carousel>
        <div
          v-else
          class="text--center"
          v-html="promotionBarContent[0]?.value"
        ></div>
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
import useComponentStore from '@/store/component'
import useSettingStore from '@/store/setting'
import {
  PROMOTION_BAR_PRIORITY_LOW,
  PROMOTION_BAR_TYPE_FIXED_CAMPAIGN,
} from '@/utils'
import { computed } from '@vue/reactivity'
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import useProductStore from '@/store/product'
import { isProductHasTags } from '@/utils/product'

const route = useRoute()
const componentStore = useComponentStore()
const settingStore = useSettingStore()
const productStore = useProductStore()
const isMounted = ref(false)

onMounted(() => {
  isMounted.value = true
})

const promotionBarContent = computed(() => {
  // const pageName = route.meta.pageName
  const allContent = [...componentStore.promotionBar.content]

  // hard code logic for chrismas occasion 2024. Need remove this logic when chrismas occasion finish
  // if (
  //   pageName == 'Product Details' &&
  //   isProductHasTags(productStore.product, ['xmas', 'occasion-Christmas Day'])
  // ) {
  //   settingStore.promotionBar?.campaigns.forEach((campaign) => {
  //     allContent.push({
  //       type: PROMOTION_BAR_TYPE_FIXED_CAMPAIGN,
  //       priority: PROMOTION_BAR_PRIORITY_LOW,
  //       value: campaign,
  //     })
  //   })
  //   allContent.sort((a, b) => {
  //     return a.priority - b.priority
  //   })
  // }

  settingStore.promotionBar?.campaigns.forEach((campaign) => {
    allContent.push({
      type: PROMOTION_BAR_TYPE_FIXED_CAMPAIGN,
      priority: PROMOTION_BAR_PRIORITY_LOW,
      value: campaign,
    })
  })
  allContent.sort((a, b) => {
    return a.priority - b.priority
  })
  return allContent
})

watch(
  () => promotionBarContent.value.length,
  (value) => {
    componentStore.promotionBar.isShow = value > 0
  },
  { immediate: true }
)
</script>
